var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStudentIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 59,
    height: 59,
    viewBox: "0 0 59 59",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 29.5,
    cy: 29.5,
    r: 29.5,
    fill: "#ff6633"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.9998 30C32.8892 30 36.0421 26.866 36.0421 23C36.0421 19.134 32.8892 16 28.9998 16C25.1105 16 21.9576 19.134 21.9576 23C21.9576 26.866 25.1105 30 28.9998 30ZM25.6669 30.2946C22.9832 28.653 19.431 29.4095 18.2135 32.2985C17.5412 33.8939 16.9936 35.6569 16.9498 37.2333C16.9223 38.2262 17.0012 39.3142 17.1183 40.3218C17.3701 42.4886 19.2907 44 21.4852 44H36.5146C38.7091 44 40.6297 42.4886 40.8815 40.3218C40.9986 39.3142 41.0775 38.2262 41.0499 37.2333C41.0062 35.6569 40.4586 33.8939 39.7863 32.2985C38.5688 29.4095 35.0165 28.653 32.3329 30.2946L32.0756 30.4519C30.1894 31.6057 27.8104 31.6057 25.9242 30.4519L25.6669 30.2946Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStudentIcon);
export default __webpack_public_path__ + "static/media/student-icon.63d79bf8444fda0197546346c1ac440c.svg";
export { ForwardRef as ReactComponent };